import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);
localStorage.lang = "fr";

const langFile = {
  fr: require("../lang/fr.json")
};

const i18n = new VueI18n({
  locale: "fr",
  fallbackLocale: "fr",
  messages: langFile,
  silentFallbackWarn: true,
  silentTranslationWarn: true
});

export const filterLang = function(value) {
  return i18n.t(value);
};

Vue.filter("i18n", filterLang);

export default i18n;
